var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "1 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2208 3.11578L6.81082 8.68911C6.43499 9.29411 6.87499 10.0824 7.58999 10.0824H14.4008C15.1158 10.0824 15.5558 9.29411 15.18 8.68911L11.7792 3.11578C11.4217 2.52911 10.5783 2.52911 10.2208 3.11578Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 20.166C18.3199 20.166 20.1667 18.3192 20.1667 16.041C20.1667 13.7628 18.3199 11.916 16.0417 11.916C13.7635 11.916 11.9167 13.7628 11.9167 16.041C11.9167 18.3192 13.7635 20.166 16.0417 20.166Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 19.7083H9.16667C9.67083 19.7083 10.0833 19.2958 10.0833 18.7917V13.2917C10.0833 12.7875 9.67083 12.375 9.16667 12.375H3.66667C3.1625 12.375 2.75 12.7875 2.75 13.2917V18.7917C2.75 19.2958 3.1625 19.7083 3.66667 19.7083Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category-icon.22e8c55ac4107290b32b105c65747299.svg";
export { ForwardRef as ReactComponent };